module.exports = {
  "secu-0002": {
    "identifierType": "USER_ID",
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};